import { LOCALE } from "../../../properties/Locale";
import * as yup from "yup";

export const trainingDataValidator = yup.object().shape({
  name: yup.string().required(LOCALE.name + LOCALE.required_field),
  // date: yup.date().required(LOCALE.date + LOCALE.required_field),
  organizer: yup.object().shape({
    id: yup.string().required(LOCALE.organizer + LOCALE.required_field),
  }),
  hourRange: yup.object().shape({
    id: yup.string().required(LOCALE.hourRange + LOCALE.required_field),
  }),
  role: yup.object().shape({
    id: yup.string().required(LOCALE.role + LOCALE.required_field),
  }),
  proofs: yup.array().required(LOCALE.proof + LOCALE.required_field),
});

export const trainingDataPointsValidator = yup.object().shape({
  points: yup.string().required(LOCALE.name + LOCALE.points),
  pointsChecked: yup.boolean().oneOf([true], "Must Approve Points"),
});
